import Konva from 'konva';
import { tokenAvatars } from './token_avatar_cache.js';

// Keep the same top-left / width / height contract as other editor shapes.
export function createCharacterTokenShape(token, attrs) {
  let avatar = null;
  const shape = new Konva.Shape({
    ...attrs,
    name: 'character-token',
    sceneFunc(context, node) {
      const diameter = node.width();
      const radius = diameter / 2;
      context.save();
      context.beginPath();
      context.arc(radius, radius, radius, 0, Math.PI * 2);
      context.closePath();
      context.save();
      context.clip();
      if (avatar?.complete && avatar.naturalWidth > 0) {
        const side = Math.min(avatar.naturalWidth, avatar.naturalHeight);
        context.drawImage(
          avatar,
          (avatar.naturalWidth - side) / 2,
          (avatar.naturalHeight - side) / 2,
          side,
          side,
          0,
          0,
          diameter,
          diameter
        );
      } else {
        context.setAttr('fillStyle', '#e9ecef');
        context.fillRect(0, 0, diameter, diameter);
        context.setAttr('fillStyle', '#495057');
        context.setAttr('font', `${diameter / 2}px sans-serif`);
        context.setAttr('textAlign', 'center');
        context.setAttr('textBaseline', 'middle');
        context.fillText('?', radius, radius);
      }
      context.restore();
      context.strokeShape(node);
      context.restore();
    }
  });
  if (token.avatarUrl) {
    avatar = tokenAvatars.load(token.avatarUrl, () => shape.getLayer()?.batchDraw());
  }
  return shape;
}
